import { render, staticRenderFns } from "./ProtectionDetails.vue?vue&type=template&id=158e987a&scoped=true&"
import script from "./ProtectionDetails.vue?vue&type=script&lang=js&"
export * from "./ProtectionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158e987a",
  null
  
)

export default component.exports